import { Button, Container, Paper, TextField } from "@mui/material";
import React, { useState } from "react";
import LoadingModal from "../../components/Modals/LoadingModal";
import Logo from "../../components/Logo";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectLabels } from "../../slices/language";
import { useNavigate } from "react-router-dom";
import { showError } from "../../utils/helpers";

const ResetPassword = () => {
  const labels = useAppSelector(selectLabels);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("");
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  const onSubmit = async () => {
    setIsLoading(true);
    setSuccessMessage(null);

    try {
      const response = await fetch(
        "https://strapi.passtrack.mx/api/custom-auth/forgot-password",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );

      if (response.ok) {
        setSuccessMessage(labels.check_email);
        setTimeout(() => navigate("/login"), 5000);
      } else {
        const error = await response.json();
        showError(dispatch, error.message || "Error al enviar el correo de recuperación.");
      }
    } catch (error) {
      console.error(error);
      showError(dispatch, "Error al procesar la solicitud.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container
      maxWidth="xs"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        paddingY: "10px",
        boxSizing: "border-box",
      }}
    >
      <LoadingModal open={isLoading} setOpen={setIsLoading} />
      <Paper
        variant="outlined"
        className="w-100 p-10 flex flex-dir-col justify-content-center align-items-center border-box scroll"
      >
        <div
          className="w-100 flex flex-dir-col align-items-center justify-content-center gap-6"
          style={{
            paddingTop: 40,
            paddingBottom: 40,
          }}
        >
          <Logo type={"passTrackLogo"} alt="passtrack" className="logo" />
          <p className="main-title mt-8">{labels.reset_password}</p>
          <p className="body-text-md mb-3 mt-6">{labels.reset_password_text}</p>

          {successMessage ? (
            <p className="success-text">{successMessage}</p>
          ) : (
            <>
              <div className="w-100 mt-8 mb-8">
                <p className="body-text-sm mb-3">{labels.email} *</p>
                <TextField
                  fullWidth
                  id="email"
                  placeholder={"email@example.com"}
                  variant="outlined"
                  value={email}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setEmail(event.target.value);
                  }}
                />
              </div>
              <Button
                fullWidth
                disableElevation
                size="large"
                variant="contained"
                disabled={!email || isLoading}
                onClick={onSubmit}
              >
                {labels.send_instructions}
              </Button>
            </>
          )}
          <p className="link-text mt-12" onClick={() => navigate("/login")}>
            {labels.log_in}
          </p>
        </div>
      </Paper>
    </Container>
  );
};

export default ResetPassword;
